import React from 'react';

import {Card} from '../global/Card';

export const Responsibilities = (props) => {
  const data = props.data || {};

  return (
    <section className="pt-lg-16 pb-lg-17 pt-md-16 pb-md-13 pt-9 pb-11">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 offset-md-6 col-xl-4">
            <div className="mb-4 mb-md-6 d-flex">
              <span className="zg-label bg-purple me-2" >{data.number}</span>
              <span className="zg-label bg-purple" >{data.subtitle}</span>
            </div>
            <h2 className="h3 mb-8 mb-md-9 mb-lg-11">
              {data.title}
            </h2>
          </div>
        </div>

        {data.items && data.items.length > 0 && (
          <div className="zg-items-grid zg-items-grid--4-col mb-6 mb-md-8">
            {
              data.items.map((item, index) => (
                <Card
                  key={index}
                  label={`0${index+1}`}
                  color={item.color}
                  title={item.title}
                  text={item.text}
                  button={item.button}
                />
              ))
            }
          </div>
        )}
        {data.text && (
          <div className="row">
            <div className="col-12 col-md-6 offset-md-6 col-xl-4">
              <p className="mb-0 zg-text-lg" dangerouslySetInnerHTML={{__html: data.text}}></p>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
